import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
    selector: 'db-tab-head',
    templateUrl: './tab-head.component.html',
    styleUrls: ['./tab-head.component.scss'],
    standalone: false
})
export class TabHeadComponent {

  @Input() tabId: string;
  @Input() activeTabId: string;
  @Input() hideTab?: boolean;
  @Output() onTabHeadClick: EventEmitter<{tabId: string, oldTabId: string}>;

  constructor() {
    this.onTabHeadClick = new EventEmitter<{tabId: string, oldTabId: string}>();
  }

  public onClick(): void {
    this.onTabHeadClick.emit({
      tabId: this.tabId,
      oldTabId: this.activeTabId
    });
  }

}
